import { getChannelGifsById } from '@/app/util/channel-api'
import Button from '@/components/button'
import { cn } from '@/util/cn'
import { IChannel } from '@giphy/js-types'
import { Grid } from '@giphy/react-components'
import { useState } from 'react'
import { desktopWidth } from 'ui/src/constants'

type Props = { channel?: IChannel }
const AllGifsGrid = ({ channel }: Props) => {
    const [showGrid, setShowGrid] = useState(false)
    return channel ? (
        <div className="min-h-[300px] flex flex-col gap-2">
            <div className={cn('flex justify-end')}>
                <Button onClick={() => setShowGrid(true)} className={cn('cursor-pointer', showGrid && 'opacity-80')}>
                    See all the {channel.display_name} Gifs
                </Button>
            </div>
            {showGrid && channel && (
                <Grid
                    columns={3}
                    gutter={10}
                    width={desktopWidth}
                    percentWidth="100%"
                    fetchGifs={async (offset: number) => await getChannelGifsById(channel.id, { offset })}
                />
            )}
        </div>
    ) : null
}

export default AllGifsGrid
